<!--
  File : ChangePassword.vue
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="400">
        <v-toolbar class="elevation-0 mb--20" color="white">
          <v-row justify="center">
            <v-toolbar-title class="primary--text">비밀번호 변경</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="mdi-account"
              v-model="login.email"
              disabled
            />
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              type="password"
              label="기존 비밀번호"
              @keyup.13.stop.prevent="next('password2')"
              v-model="password"
            />
            <v-text-field
              id="password2"
              prepend-icon="mdi-lock"
              type="password"
              label="새 비밀번호 (6자이상)"
              @keyup.13.stop.prevent="next('confirm')"
              v-model="password2"
            />
            <v-text-field
              id="confirm"
              prepend-icon="mdi-lock"
              type="password"
              label="새 비밀번호확인"
              @keyup.13.stop.prevent="change()"
              v-model="confirm"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right" cols="12">
            <v-btn class="mr-3 elevation-0 font-14" color="normal" @click.prevent="cancel()">취소</v-btn>
            <v-btn color="secondary" class="elevation-0 font-14" @click.prevent="change()">적용</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'ChangePassword',

  data () {
    return {
      login: null,
      password: '',
      password2: '',
      confirm: '',
    }
  },

  methods: {
    next: function (type) {
      if (type == 'password2' && this.password.length >= 6) {
        document.getElementById('password2').focus()
      }
      else if (type == 'confirm' && this.password2.length >= 6) {
        document.getElementById('confirm').focus()
      }
    },

    change: function () {
      if (this.password.length < 6) {
        alert('정확한 비밀번호를 입력해주세요.')
        document.getElementById('password').focus()
        return
      }
      if (this.password2.length < 6) {
        alert('정확한 비밀번호를 입력해주세요.')
        document.getElementById('password2').focus()
        return
      }
      if (this.confirm != this.password2) {
        alert('정확한 비밀번호를 입력해주세요.')
        document.getElementById('confirm').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.login.id)
      params.append('email', this.login.email)
      params.append('password', this.password)
      params.append('password2', this.password2)
      axios.post('/api/user/change', params, util.headers)
      .then(response => {
        if (response.data.error) {
          alert(response.data.error)
        }
        else if (response.data.success) {
          alert('비밀번호가 변경되었습니다. 다시 로그인하세요.')
          localStorage.setItem('login', '')
          this.$emit('login', null)
          this.$router.push('/login')
        }
      })
    },

    cancel: function () {
      this.$router.push('/')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
    }
    if (this.login) {
      this.$emit('login', this.login)
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.mb--20 {
  margin-bottom: -20px;
}
</style>
